module.exports = __webpack_public_path__ + "img/3xBAR.31bf5a09.png";